<template>
  <pie-chart
    v-if="hasChartData"
    :chart-data="chartData"
    :tooltips-callback-cfg="tooltipsCallbackCfg"
    :width="300"
    :height="300"
  ></pie-chart>
  <no-data-found v-else class="mx-auto"></no-data-found>
</template>

<script>
import PieChart from "@/components/Base/PieChart";
import NoDataFound from "@/components/Base/Illustration/NoDataFound.vue";
import { GRADE_COLORS } from "../utils";

export default {
  name: "grade-chart",
  components: { PieChart, NoDataFound },
  props: ["gradeLetter"],
  data() {
    return {
      tooltipsCallbackCfg: {
        title: {
          prefix: "Grade letter"
        },
        label: true,
        afterLabel: {
          subfix: "students"
        }
      }
    };
  },
  computed: {
    chartData() {
      return this.generateChartDataFrom(this.gradeLetter);
    },

    hasChartData() {
      return this.chartData?.datasets[0]?.data?.length;
    }
  },
  methods: {
    generateChartDataFrom(gradeLetter) {
      if (!gradeLetter) return null;

      const { labels, data } = gradeLetter;

      return {
        labels,
        datasets: [
          {
            data,
            backgroundColor: labels.map(label => GRADE_COLORS[label]),
            borderWidth: 1
          }
        ]
      };
    }
  }
};
</script>

<style lang="scss" scoped></style>
